import "core-js/modules/es.object.to-string.js";
// src/store/modules/dashboard.js
import { getTodoList as _getTodoList } from '@/api/dashboard';
var state = {
  todoList: []
};
var mutations = {
  SET_TODO_LIST: function SET_TODO_LIST(state, todoList) {
    state.todoList = todoList;
  }
};
var actions = {
  // 获取待办列表
  getTodoList: function getTodoList(_ref) {
    var commit = _ref.commit;
    return new Promise(function (resolve, reject) {
      _getTodoList().then(function (response) {
        commit('SET_TODO_LIST', response.data.list);
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // 刷新待办列表（SignalR 通知时调用）
  refreshTodoList: function refreshTodoList(_ref2) {
    var dispatch = _ref2.dispatch;
    return dispatch('getTodoList');
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};